import './App.css';
import bannerfuturelink from './FL.png'
import iconlink from './link.svg'
import javascripticon from './Javascript.svg'
import reacticon from './React.svg'
import nodeicon from './nodejs.svg'
import mysqlicon from './mysql.svg'
import stticon from './stt.svg'
import expressicon from './express.svg'
import anchoricon from './anchor.svg'
import phantomicon from './phantom.svg'
import metamaskicon from './metamask.svg'
import nearicon from './Near.png'
import nearwalleticon from './nearwallet.png'
import bannerinfidea from './infidea.png'
import banneraci from './acitelkom.png'
import bannermtf from './mtfmandiri.png'
import bannerjardinx from './jardinxlp.png'
import bannerindi from './indi.png'
import bannermilkyverse from './milkyverse.png'
import bannernagmi from './nagmi.png'
import bannernearpaca from './nearpaca.png'
import { Link } from 'react-router-dom'

function Blockchain() {
  return (
<body className='Background' >

    <div className="Navbar">
      <Link to="/artificial-intelligence" className="nav-link">Artificial Intelligence</Link>
      <Link to="/web-app-development" className="nav-link">Web & App Development</Link>
      <Link to="/blockchain" className="nav-link">Blockchain</Link>
    </div>
    
    <p className='Title' >Projects I’ve Worked on</p>

    <div className='Card5'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>JardinX</p>
          <p className='Deskripsi'>
          Mengembangan sebuah platform web3 yang digunakan untuk trading NFT image. Berbagai macam fitut yang dikembangkan seperti bid, sell, dan buy.          </p>
          <img className='Banner' src={bannerjardinx} alt='jardinxlp' ></img>
        </div>          
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
            {/* <button className='Button-Category'>Mobile App</button> */}
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={expressicon} alt='express'></img>
              <p>ExpressJS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={anchoricon} alt='anchor'></img>
              <p>Anchor</p>
            </button>
          </div>

          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={phantomicon} alt='phantom'></img>
              <p>Phantom</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={metamaskicon} alt='metamask'></img>
              <p>Metamask</p>
            </button>
          </div>

          <a href="https://jardinx.infidea.dev" className="Link" target="_blank" rel="noopener noreferrer">
            <img className="icon" src={iconlink} alt="link" />
            <p>Go to JardinX</p>
          </a>
        </div>  
      </div>
    </div>

    <div className='Card7'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Milkyverse</p>
          <p className='Deskripsi'>
          penciptaan dunia virtual berupa NFT marketplace yang terintegrasi dengan teknologi blockchain.          
          </p>
          <img className='Banner' src={bannermilkyverse} alt='milkyverse' ></img>
        </div>          
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
            {/* <button className='Button-Category'>Mobile App</button> */}
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javascripticon} alt='Javascript'></img>
              <p>JavaScript</p>
              </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
              </button>
          </div>
          <a href="https://milkyverse.infidea.dev" className="Link" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={iconlink} alt="link" />
              <p>Go to Milkyverse</p>
          </a>
        </div> 
      </div>
    </div>

    <div className='Card10'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Nagmi</p>
          <p className='Deskripsi'>
          Nevada adalah perusahaan teknologi kreatif yang berfokus pada pengembangan dan penjualan NFT (Non-Fungible Token) gambar. Perusahaan tersebut menciptakan karya unik yang memiliki nilai koleksi dan investasi.          
          </p>
          <img className='Banner' src={bannernagmi} alt='nagmi' ></img>
        </div>          
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
            {/* <button className='Button-Category'>Mobile App</button> */}
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={nearicon} alt='Near'></img>
              <p>Smart Contract NEAR</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nearicon} alt='Near'></img>
              <p>NEP-171</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nearwalleticon} alt='nearwallet'></img>
              <p>Wallet Near</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
          </div>
          <a href="https://nagmi.infidea.dev" className="Link" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={iconlink} alt="link" />
              <p>Go to Nagmi</p>
          </a>
        </div> 
      </div>
    </div>

    <div className='Card11'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Nearpaca</p>
          <p className='Deskripsi'>
          Mengembangan Web3 untuk meminting/membeli sebuah collection NFT yang diberi nama Nearpaca.          
          </p>
          <img className='Banner' src={bannernearpaca} alt='nearpaca' ></img>
        </div>          
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
            {/* <button className='Button-Category'>Mobile App</button> */}
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={nearicon} alt='Near'></img>
              <p>Smart Contract NEAR</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nearicon} alt='Near'></img>
              <p>NEP-171</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nearwalleticon} alt='nearwallet'></img>
              <p>Wallet Near</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
              </button>
          </div>
          <a href="https://nearpaca.infidea.dev" className="Link" target="_blank" rel="noopener noreferrer">
              <img className="icon" src={iconlink} alt="link" />
              <p>Go to Nearpaca</p>
          </a>
        </div> 
      </div>
    </div>

    <div className='footer'>
      <a href="https://infidea.id/" className="namefooter" target="_blank" rel="noopener noreferrer">
        <p>2025 Copyright © infidea</p>
      </a>
    </div>
</body>
);
  

  
}

export default Blockchain;
